import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { ReportProblemIcon } from '@components/Icons'
import { colors } from '@lib/colors'

interface QueryErrorProps {
  text: string
}

export default function ({ text }: QueryErrorProps) {
  return (
    <View style={ styles.wrapper }>
      <ReportProblemIcon color={colors.red[500]} size={30} />
      <Text style={ styles.text }>{text}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    paddingTop: 40,
  },
  text: {
    paddingTop: 20,
    fontSize: 18,
    color: colors.red[500],
  },
})
